import React from "react";

const InformationalDashboard = React.lazy(() => import("../../views/dashboard/InformationalDashboard"));

const AuditTrail = React.lazy(() => import("../../views/reports/AuditTrail"));
const SalesReport = React.lazy(() => import("../../views/reports/Sales"));
const BudgetCargoReport = React.lazy(() => import("../../views/reports/BudgetCargo"));
const ActualCargoReport = React.lazy(() => import("../../views/reports/ActualCargo"));

const BudgetCIF = React.lazy(() => import("../../views/operations/BudgetCIF"));
const DailyPlatt = React.lazy(() => import("../../views/operations/DailyPlatt"));
const PricingWindow = React.lazy(() => import("../../views/operations/PricingWindow"));
const SellingWindow = React.lazy(() => import("../../views/operations/SellingWindow"));
const CargoApproval = React.lazy(() => import("../../views/operations/CargoApproval"));
const HedgeApproval = React.lazy(() => import("../../views/operations/HedgeApproval"));
const ApprovedCargo = React.lazy(() => import("../../views/operations/CargoApproved"));

const ActualCIF = React.lazy(() => import("../../views/operations/ActualCIF"));
// const ActualInflow = React.lazy(() => import("../../views/operations/Sales"));
// const Trigger = React.lazy(() => import("../../views/operations/Triggers"));

const Products = React.lazy(() => import("../../views/preference/Products"));
const Users = React.lazy(() => import("../../views/preference/Users"));
const UserList = React.lazy(() => import("../../views/preference/UserList"));
const Company = React.lazy(() => import("../../views/preference/Company"));
const Costs = React.lazy(() => import("../../views/preference/Costs"));
const UserAccount = React.lazy(() => import("../../views/preference/UserAccount"));
const Holidays = React.lazy(() => import("../../views/preference/Holidays"));

const routes = [
    { path: "/dashboard/informational", component: InformationalDashboard },

    { path: "/operation/budget_cif", component: BudgetCIF },
    { path: "/operation/daily_platts/*", component: DailyPlatt },
    { path: "/operation/price_window", component: PricingWindow },
    { path: "/operation/sell_window", component: SellingWindow },
    { path: "/approvals/cargo/*", component: CargoApproval },
    { path: "/approvals/approved_cargo/*", component: ApprovedCargo },
    { path: "/approvals/hedge/*", component: HedgeApproval },

    { path: "/operation/actual_cif", component: ActualCIF },
    // { path: "/operation/trigger", component: Trigger },
    // { path: "/operation/inflow/*", component: ActualInflow },
    
    { path: "/report/audit_trail", component: AuditTrail },
    { path: "/report/budget_cargo_report", component: BudgetCargoReport },
    { path: "/report/actual_cargo_report", component: ActualCargoReport },
    { path: "/report/sales_report", component: SalesReport },

    { path: "/setting/product", component: Products },
    { path: "/setting/cost", component: Costs },
    { path: "/setting/role", component: Users },
    { path: "/setting/account", component: UserAccount },
    { path: "/setting/role/users", component: UserList },
    { path: "/setting/company", component: Company },
    { path: "/setting/holiday", component: Holidays },
];

export default routes;
